/*
  الجداول المتجاوبة لكل الشاشات (مرة واحدة في Layout، لا تعديل في الجداول نفسها):

  - سطح المكتب: الجدول كما هو بكل أعمدته.
  - اللوحي والجوال: الجدول يتمرر أفقياً داخل إطاره، والعمود الأول (المفتاح) ثابت أثناء التمرير.
  - الجوال (< 768px): الجداول المناسبة (رأس واحد، ≤ 12 عموداً، بلا خلايا مدموجة) تصير بطاقات:
    كل خلية «اسم العمود: القيمة»، تظهر الأعمدة الأساسية (أول ثلاثة + الإجراءات)، والباقي خلف «عرض التفاصيل».
    لا تختفي أي بيانات.

  الوحدة تضيف سمات data-* فقط (لا تنقل عناصر React ولا تحذفها)، والتنسيق في styles/responsive.css.
  جدول لا يناسب البطاقات (مصفوفات التقويم، الطباعة، التحرير الكثيف) يُستثنى بـ data-no-cards على الجدول أو أحد آبائه.
*/
const MAX_CARD_COLUMNS = 12;
const KEY_COLUMNS = 3;

function headerCells(table) {
  const head = table.tHead;
  if (!head || head.rows.length !== 1) return null;
  const cells = [...head.rows[0].cells];
  if (cells.some((c) => c.colSpan > 1 || c.rowSpan > 1)) return null;
  return cells;
}

function label(th) {
  return (th.innerText || th.textContent || "").replace(/\s+/g, " ").trim();
}

function enhance(table) {
  if (table.closest("[data-no-cards], .leave-calendar-table, .dw-preview, .print-only, .MuiTableContainer-root")) {
    if (table.dataset.rt) delete table.dataset.rt;
    return;
  }
  const ths = headerCells(table);
  const bodies = [...table.tBodies];
  if (!ths || ths.length < 3 || ths.length > MAX_CARD_COLUMNS || bodies.length === 0) {
    table.dataset.rt = "scroll";
    return;
  }
  const labels = ths.map(label);
  let mergedBody = false;
  for (const tb of bodies) {
    for (const tr of tb.rows) {
      const cells = [...tr.cells];
      if (cells.length !== labels.length) {
        // صف رسالة (لا توجد بيانات / تحميل) بخلية ممتدة — يُعرض بعرض البطاقة
        if (cells.length === 1) { tr.dataset.rtFull = ""; continue; }
        mergedBody = true;
        continue;
      }
      if ("rtFull" in tr.dataset) delete tr.dataset.rtFull;
      let hidden = 0;
      let data = 0;
      cells.forEach((td, i) => {
        if (td.dataset.label !== labels[i]) td.dataset.label = labels[i];
        // خلايا الإجراءات (أزرار/روابط/حقول) ظاهرة دائماً في آخر البطاقة، وخانة التحديد في أولها؛
        // ومن خلايا البيانات تظهر أول ثلاث ذات عنوان (الأعمدة الأساسية) والباقي خلف «عرض التفاصيل»
        const ctl = td.querySelector("button, a[href], input, select, textarea");
        const check = ctl && td.querySelector('input[type="checkbox"]') && !td.textContent.trim();
        if (ctl) td.dataset.rtCtl = check ? "check" : "action";
        else if ("rtCtl" in td.dataset) delete td.dataset.rtCtl;
        const key = ctl || (labels[i] !== "" && data++ < KEY_COLUMNS);
        if (key) td.dataset.rtKey = "";
        else { if ("rtKey" in td.dataset) delete td.dataset.rtKey; hidden++; }
      });
      if (hidden > 0) tr.dataset.rtHidden = String(hidden);
      else if ("rtHidden" in tr.dataset) delete tr.dataset.rtHidden;
    }
  }
  table.dataset.rt = mergedBody ? "scroll" : "cards";
}

function enhanceAll(root) {
  root.querySelectorAll("table").forEach(enhance);
}

/** يُفعَّل مرة واحدة على حاوية المحتوى؛ يعيد دالة الإيقاف. */
export function initResponsiveTables(root) {
  if (!root || typeof MutationObserver === "undefined") return () => {};
  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; enhanceAll(root); });
  };
  enhanceAll(root);
  // تغيّر الصفوف أو الأعمدة (تحميل البيانات، الترقيم، الفلاتر) يعيد الوسم — السمات لا تُراقَب فلا تكرار
  const mo = new MutationObserver(schedule);
  mo.observe(root, { childList: true, subtree: true, characterData: true });

  // «عرض التفاصيل» في البطاقة: النقر على شريط أسفل البطاقة (الصف نفسه لا خلاياه)
  const onClick = (e) => {
    const tr = e.target;
    if (!(tr instanceof HTMLTableRowElement) || !tr.dataset.rtHidden) return;
    const table = tr.closest('table[data-rt="cards"]');
    if (!table || !window.matchMedia("(max-width: 767.98px)").matches) return;
    e.stopPropagation();
    e.preventDefault();
    if ("rtOpen" in tr.dataset) delete tr.dataset.rtOpen;
    else tr.dataset.rtOpen = "";
  };
  root.addEventListener("click", onClick, true);
  return () => {
    mo.disconnect();
    root.removeEventListener("click", onClick, true);
    if (frame) cancelAnimationFrame(frame);
  };
}
